/* tslint:disable */
type TipoPessoaEnum =
  'FISICA' |
  'JURIDICA';
module TipoPessoaEnum {
  export const FISICA: TipoPessoaEnum = 'FISICA';
  export const JURIDICA: TipoPessoaEnum = 'JURIDICA';
  export function values(): TipoPessoaEnum[] {
    return [
      FISICA,
      JURIDICA
    ];
  }
}

export { TipoPessoaEnum }